import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export class JsonCell extends GridCell {
  public render() {
    return <td>
      <div>
        <pre>
          <code>
            {JSON.stringify(this.props.dataItem[this.props.field])}
          </code>
        </pre>
      </div>
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/json_cell.tsx